import { CarnetEquipment } from "../../types/types";

type EquipementImageProps = {
  equipment: CarnetEquipment;
  large?: boolean;
};

export const EQUIPMENT_TYPEs = [
  "airconditioner",
  "boiler",
  "dishwasher",
  "generic",
  "hood",
  "lightBulb",
  "oven",
  "refrigerated",
  "refrigerator",
  "screen",
  "smallSpaceHeater",
  "smartphone",
  "solar",
  "tableLamp",
  "thermostat",
  "tyres",
  "ventilation",
  "wallSpaceHeater",
  "wash",
  "waterHeater",
];

export const EQUIPMENT_ASSETS = {
  airconditioner: require("../../assets/illustrations/equipments/boiler.png"),
  boiler: require("../../assets/illustrations/equipments/boiler.png"),
  dishwasher: require("../../assets/illustrations/equipments/dishwasher.png"),
  generic: require("../../assets/illustrations/equipments/generic.png"),
  hood: require("../../assets/illustrations/equipments/hood.png"),
  lightBulb: require("../../assets/illustrations/equipments/light_bulb.png"),
  oven: require("../../assets/illustrations/equipments/oven.png"),
  refrigerated: require("../../assets/illustrations/equipments/refrigerated.png"),
  refrigerator: require("../../assets/illustrations/equipments/refrigerator.png"),
  screen: require("../../assets/illustrations/equipments/screen.png"),
  smallSpaceHeater: require("../../assets/illustrations/equipments/small_space_heater.png"),
  smartphone: require("../../assets/illustrations/equipments/smartphone.png"),
  solar: require("../../assets/illustrations/equipments/solar.png"),
  tableLamp: require("../../assets/illustrations/equipments/table_lamp.png"),
  thermostat: require("../../assets/illustrations/equipments/thermostat.png"),
  tyres: require("../../assets/illustrations/equipments/tyres.png"),
  ventilation: require("../../assets/illustrations/equipments/ventilation.png"),
  wallSpaceHeater: require("../../assets/illustrations/equipments/wall_space_heater.png"),
  wash: require("../../assets/illustrations/equipments/wash.png"),
  waterHeater: require("../../assets/illustrations/equipments/water_heater.png"),
};

export const EquipementImage = ({ equipment, large }: EquipementImageProps) => {
  console.log("equipment.product_group_code", equipment.product_group_code);
  return (
    <img
      // use onlune url
      src={
        ProductGroupCodeToAsset(equipment.product_group_code || "") ||
        EquipmentTypeToAsset(equipment.product_group_code || "") ||
        ""
      }
      style={{
        width: large ? 150 : 100,
        height: large ? 150 : 100,
        objectFit: "contain",
        padding: 0,
      }}
    />
  );
  // your logic here
};

export const EquipementImageAll = ({ equipment }: EquipementImageProps) => {
  console.log("equipment.product_group_code", equipment.product_group_code);
  return (
    <img
      // use onlune url
      src={EquipmentTypeToAsset(equipment.product_group_code || "")}
      style={{
        width: 100,
        height: 100,
        objectFit: "contain",
        padding: 20,
      }}
    />
  );
  // your logic here
};
export const EquipmentTypeToAsset = (type: string) => {
  switch (type) {
    case "airconditioner":
      return EQUIPMENT_ASSETS.airconditioner;
    case "boiler":
      return EQUIPMENT_ASSETS.boiler;
    case "dishwasher":
      return EQUIPMENT_ASSETS.dishwasher;
    case "hood":
      return EQUIPMENT_ASSETS.hood;
    case "lightBulb":
      return EQUIPMENT_ASSETS.lightBulb;
    case "oven":
      return EQUIPMENT_ASSETS.oven;
    case "refrigerated":
      return EQUIPMENT_ASSETS.refrigerated;
    case "refrigerator":
      return EQUIPMENT_ASSETS.refrigerator;
    case "screen":
      return EQUIPMENT_ASSETS.screen;
    case "smallSpaceHeater":
      return EQUIPMENT_ASSETS.smallSpaceHeater;
    case "smartphone":
      return EQUIPMENT_ASSETS.smartphone;
    case "solar":
      return EQUIPMENT_ASSETS.solar;
    case "tableLamp":
      return EQUIPMENT_ASSETS.tableLamp;
    case "thermostat":
      return EQUIPMENT_ASSETS.thermostat;
    case "tyres":
      return EQUIPMENT_ASSETS.tyres;
    case "ventilation":
      return EQUIPMENT_ASSETS.ventilation;
    case "wallSpaceHeater":
      return EQUIPMENT_ASSETS.wallSpaceHeater;
    case "wash":
      return EQUIPMENT_ASSETS.wash;
    case "waterHeater":
      return EQUIPMENT_ASSETS.waterHeater;
    default:
      return EQUIPMENT_ASSETS.generic;
  }
};
export const ProductGroupCodeToAsset = (type: string) => {
  switch (type) {
    case "airconditioners":
      return EQUIPMENT_ASSETS.airconditioner;

    case "solidfuelboilers":
      return EQUIPMENT_ASSETS.boiler;
    case "solidfuelboilerpackages":
      return EQUIPMENT_ASSETS.boiler;

    case "dishwashers":
      return EQUIPMENT_ASSETS.dishwasher;
    case "dishwashers2019":
      return EQUIPMENT_ASSETS.dishwasher;

    case "ovens":
      return EQUIPMENT_ASSETS.oven;

    case "rangehoods":
      return EQUIPMENT_ASSETS.hood;

    case "lamps":
      return EQUIPMENT_ASSETS.tableLamp;

    case "lightsources":
      return EQUIPMENT_ASSETS.lightBulb;

    case "electronicdisplays":
      return EQUIPMENT_ASSETS.screen;
    case "televisions":
      return EQUIPMENT_ASSETS.screen;

    case "smartphonestablets20231669":
      return EQUIPMENT_ASSETS.smartphone;

    case "refrigeratingappliances":
      return EQUIPMENT_ASSETS.refrigerator;

    case "refrigeratingappliances2019":
      return EQUIPMENT_ASSETS.refrigerator;

    case "refrigeratingappliancesdirectsalesfunction":
      return EQUIPMENT_ASSETS.refrigerator;

    case "professionalrefrigeratedstoragecabinets":
      return EQUIPMENT_ASSETS.refrigerated;

    case "washingmachines":
      return EQUIPMENT_ASSETS.wash;

    case "washingmachines2019":
      return EQUIPMENT_ASSETS.wash;

    case "washerdriers":
      return EQUIPMENT_ASSETS.wash;

    case "washerdriers2019":
      return EQUIPMENT_ASSETS.wash;

    case "tumbledriers":
      return EQUIPMENT_ASSETS.wash;

    case "tumbledryers20232534":
      return EQUIPMENT_ASSETS.wash;

    case "localspaceheaters":
      return EQUIPMENT_ASSETS.smallSpaceHeater;

    case "spaceheaters":
      return EQUIPMENT_ASSETS.wallSpaceHeater;
    case "spaceheaterpackages":
      return EQUIPMENT_ASSETS.wallSpaceHeater;

    case "spaceheatertemperaturecontrol":
      return EQUIPMENT_ASSETS.thermostat;

    case "spaceheatersolardevice":
      return EQUIPMENT_ASSETS.solar;

    case "residentialventilationunits":
      return EQUIPMENT_ASSETS.ventilation;

    case "tyres":
      return EQUIPMENT_ASSETS.tyres;

    case "waterheaters":
      return EQUIPMENT_ASSETS.waterHeater;

    case "waterheaterpackages":
      return EQUIPMENT_ASSETS.waterHeater;

    case "waterheatersolardevices":
      return EQUIPMENT_ASSETS.solar;

    case "hotwaterstoragetanks":
      return EQUIPMENT_ASSETS.waterHeater;

    default:
      return null;
  }
};
